// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
/** Lazy loader for the DeletePlanDialogContainer */ export const DeletePlanDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-delete-plan-dialog" */ "./DeletePlanDialogContainer")).then((module)=>({
            default: module.DeletePlanDialogContainer
        }));
/** Lazy loading wrapper for DeletePlanDialogContainer */ export const LazyDeletePlanDialogContainer = /*#__PURE__*/ lazy(DeletePlanDialogContainerLazyLoader);
